// ── Centralized legal / contact identity for /terms and /privacy ──────────
//
// CONTACT_EMAIL reuses the same official address already shown
// consistently on the public /contact page (src/app/contact/page.tsx,
// both the SQ and EN sections) — not invented for this task.
//
// LEGAL_ENTITY_NAME / LEGAL_ENTITY_NIPT / LEGAL_ENTITY_ADDRESS are NOT
// established anywhere else in this codebase (confirmed via a repo-wide
// audit: no registered company name, no NIPT, no formal business
// address exists in any page, config, or env file). Per instruction,
// these are left blank rather than invented. The /terms and /privacy
// pages only render a field here if it is non-empty, so leaving them
// blank means the pages simply show the contact email with no fabricated
// entity line — fill these in before launch and both pages pick up the
// change automatically, with no other code change needed.
export const CONTACT_EMAIL = 'info@rezervo-online.al';

export const LEGAL_ENTITY_NAME = ''; // e.g. "Rezervo Online Sh.p.k."
export const LEGAL_ENTITY_NIPT = ''; // e.g. "L12345678A"
export const LEGAL_ENTITY_ADDRESS = ''; // e.g. "Rruga ..., Tiranë, Shqipëri"
